import * as React from 'react';
import CommentIcon from '@mui/icons-material/Comment';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { styled } from '@mui/material/styles';
import normalScaleIcon from '../../../../../../../assets/images/normal_scale_24px.svg';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ThumbnailActionIcon } from '../state/thumbnail-action-icons';

const INFO_BLUE = '#7ba4d2';
const WARNING_RED = '#d93934';
const STALE_GREY = 'rgb(117, 117, 117)';

const IconsContainer = styled('div')({
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    display: 'flex',
    gap: '4px',
    zIndex: 100
});

const Badge = styled('span')<{ backgroundColor: string }>(({ backgroundColor }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '34px',
    height: '34px',
    borderRadius: '17px',
    color: '#fff',
    backgroundColor,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
    fontSize: '18px'
}));

type BadgeDefinition = {
    backgroundColor: string;
    titleKey: string;
    content: React.ReactNode;
};

const BADGES: Record<ThumbnailActionIcon, BadgeDefinition> = {
    [ThumbnailActionIcon.UploadedNormal]: {
        backgroundColor: INFO_BLUE,
        titleKey: 'image-processing/page/list/thumbnail/icons/has-uploaded-normal',
        content: <img src={normalScaleIcon} alt="" width={24} height={24} />
    },
    [ThumbnailActionIcon.NeedsEditing]: {
        backgroundColor: WARNING_RED,
        titleKey: 'image-processing/page/list/thumbnail/icons/needs-editing',
        content: <FeedbackIcon fontSize="inherit" />
    },
    [ThumbnailActionIcon.OldNeedsEditing]: {
        backgroundColor: STALE_GREY,
        titleKey: 'image-processing/page/list/thumbnail/icons/has-old-needs-editing',
        content: <FeedbackIcon fontSize="inherit" />
    },
    [ThumbnailActionIcon.HasComment]: {
        backgroundColor: INFO_BLUE,
        titleKey: 'image-processing/page/list/thumbnail/icons/has-comments',
        content: <CommentIcon fontSize="inherit" />
    },
    [ThumbnailActionIcon.HasOldComment]: {
        backgroundColor: STALE_GREY,
        titleKey: 'image-processing/page/list/thumbnail/icons/has-old-comments',
        content: <CommentIcon fontSize="inherit" />
    }
};

type ThumbnailActionIconsProps = {
    icons: ThumbnailActionIcon[];
};

export function ThumbnailActionIcons({ icons }: ThumbnailActionIconsProps) {
    if (icons.length === 0) {
        return null;
    }

    return (
        <IconsContainer>
            {icons.map((icon) => {
                let badge = BADGES[icon];
                let title = Translate(badge.titleKey);

                return (
                    <Badge
                        key={icon}
                        role="img"
                        aria-label={title}
                        title={title}
                        backgroundColor={badge.backgroundColor}
                        data-testid={`thumbnail-action-${icon}`}
                    >
                        {badge.content}
                    </Badge>
                );
            })}
        </IconsContainer>
    );
}
